/* =====================================================================
   mw-artwork.js — moves the description and the file into the product
   form, and refuses to pretend if it cannot.
===================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.mw-artwork');
  if (!root) return;

  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  var fields = root.querySelector('.mw-artwork__fields');

  if (!form || !fields) {
    /* The fields would not reach the order, so they are not shown as if
       they would. The customer is told to email instead — which is the
       truth, and the same instruction the fallback line already gives. */
    return;
  }

  /* Put them just above the buy button, inside the form, so Horizon's
     `new FormData(form)` picks up both the text and the file. */
  var button = form.querySelector('[type="submit"], .add-to-cart, button');
  if (button && button.parentNode === form) form.insertBefore(fields, button);
  else form.appendChild(fields);

  root.hidden = false;
  fields.classList.add('mw-artwork__fields--mounted');

  /* Shopify rejects an upload over 20 MB with an error that reads like
     a server fault. Saying so first is kinder than letting them find
     out after they have filled the form in. */
  var file = fields.querySelector('input[type="file"]');
  var warn = fields.querySelector('.mw-artwork__fallback');
  if (file && warn) {
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      var tooBig = f && f.size > 20 * 1024 * 1024;
      warn.classList.toggle('is-loud', !!tooBig);
      if (tooBig) file.value = '';
    });
  }

  /* the inches under the size buttons, same as the personalisation panel */
  var cfg = (window.MW_PERSONALIZE || {})[root.getAttribute('data-handle')];
  if (cfg && window.MWSizeNote) MWSizeNote.mountWhenReady(cfg.sizes);
})();
